import { render } from "./StorefrontOrderConfirmation.vue?vue&type=template&id=b2cd8b96"
import script from "./StorefrontOrderConfirmation.vue?vue&type=script&lang=js"
export * from "./StorefrontOrderConfirmation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__